import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import { gql, graphql } from 'react-apollo'
import WelcomeHOC from './components/WelcomeHOC'
import SelectGenderHOC from './components/SelectGenderHOC'
import SweepsCardHOC from './components/SweepsCardHOC'
import ShareCardHOC from './components/ShareCardHOC'
import RateTheLookHOC from './components/RateTheLookHOC'
import CheckLaterHOC from './components/CheckLaterHOC'
import Branding from './templates/Branding'

//import config from './config'
import moment from 'moment'
const _ = require('lodash')



const outFitsQuery = gql`
query ($today: String){
  allOutfits (
    orderBy: createdAt_DESC
    filter: {
      date_lte: $today
    }
  ){
    id
    imageurl
    location
    createdAt
  }
}
`

const today = moment().format('M/DD/YY')

const vars = {today: today}

const propsMap = (props) => {
  console.log('propsMap data', props.data)
  props.data.allOutfits = _.sampleSize(props.data.allOutfits, 10)
  return props
}

class App extends React.Component {

  render () {

    const WelcomeRoute = (props) => {
      //console.log('SelectGender props', props, 'this', this)
        return (
          <WelcomeHOC data={this.props.data} {...props} />
          )
    }

    const RateTheLookRoute = (props) => {
      //console.log('SelectGender props', props, 'this', this)
        return (
          <RateTheLookHOC data={this.props.data} {...props} />
          )
    }


      return (
        <Router>
            <Switch>
              <Route exact path="/" component={SelectGenderHOC} />
              <Route path="/welcome/:gender" render={WelcomeRoute} />
              <Route path="/ratethelook/:gender/:cardset" render={RateTheLookRoute} />
              <Route path="/ratethelook/:gender/:cardset/:card" render={RateTheLookRoute} />
              <Route path="/sweeps/:gender" component={SweepsCardHOC} />
              <Route path="/share/:gender" component={ShareCardHOC} />
              <Route path="/later" component={CheckLaterHOC} />
              <Route path='*' component={SelectGenderHOC} />
            </Switch>
        </Router>
      )

  }
}

export default graphql(outFitsQuery, { props: propsMap, options: {variables: vars}})(App);



// WEBPACK FOOTER //
// ./src/app.js